import React from 'react';
import { painPoints } from '../data/mock';

const ProblemSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-slate-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-white to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <span className="inline-block text-sm font-bold text-rose-600 uppercase tracking-wider mb-4 px-4 py-2 bg-rose-50 rounded-full">
            The Problem
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-6 leading-tight">
            Sounds familiar?
            <span className="block text-slate-400 text-3xl md:text-4xl mt-2">(We thought so.)</span>
          </h2>
        </div>

        {/* Pain Points Grid - Bento style */}
        <div className="grid md:grid-cols-2 gap-4">
          {painPoints.map((point, index) => (
            <div
              key={point.id}
              className={`group relative p-6 md:p-8 rounded-3xl border-2 border-white hover:border-transparent transition-all duration-500 hover:-translate-y-2 cursor-pointer overflow-hidden shadow-sm hover:shadow-xl ${
                index === 0 ? 'bg-white hover:bg-gradient-to-br hover:from-rose-50 hover:to-orange-50' :
                index === 1 ? 'bg-white hover:bg-gradient-to-br hover:from-amber-50 hover:to-yellow-50' :
                index === 2 ? 'bg-white hover:bg-gradient-to-br hover:from-emerald-50 hover:to-teal-50' :
                'bg-white hover:bg-gradient-to-br hover:from-sky-50 hover:to-cyan-50'
              }`}
            >
              {/* Large emoji background */}
              <span className="absolute -right-4 -bottom-4 text-8xl md:text-9xl opacity-10 group-hover:opacity-20 transition-opacity">
                {point.emoji}
              </span>
              
              <div className="relative z-10">
                <span className="text-4xl md:text-5xl mb-4 md:mb-6 block">{point.emoji}</span>
                <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-3">
                  {point.title}
                </h3>
                <p className="text-base md:text-lg text-slate-600 leading-relaxed">
                  {point.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom message */}
        <div className="mt-16 text-center">
          <p className="text-2xl md:text-3xl font-bold text-slate-900">
            Time to fix that. <span className="bg-gradient-to-r from-rose-500 to-orange-500 bg-clip-text text-transparent">For real.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
